// extracted by mini-css-extract-plugin
export default {"wrapper":"zn-z","response":"An-z","error":"Bn-z","disabled":"Cn-z","buttons":"Dn-z","feedbackQuestionSection":"En-z","yesNoWrapper":"Fn-z"};